export default "__VITE_ASSET__BGfDuNQG__"